<select
    [ngClass]="
        !!display && display === 'small' ? 'form-control-sm' : 'form-control'
    "
    [disabled]="disabled"
    [(ngModel)]="selectedRole"
    (change)="selectionChanged()"
    [compareWith]="compareRole"
>
    <option *ngFor="let role of allRoles" [ngValue]="role">
        {{ 'db.roles.' + role | translate }}
    </option>
</select>
